<template>
    <div>
    <el-form :model="searchForm" ref="searchForm" label-width="120px">
           <el-row>
               <el-col :lg="10" :offset="2">
              <el-form-item label="品牌:">
                   <el-radio-group v-model="searchForm.brand_id">
                   <el-radio :label="1">N牌</el-radio>
                   <el-radio :label="2">S牌</el-radio>
               </el-radio-group>
              </el-form-item>
              
               
               </el-col>
               <el-col :lg="12">
              <el-form-item label="品項:">
                  <el-input v-model="searchForm.name" style="width:50%;"></el-input>
                  
              </el-form-item>
              
               
               </el-col>
           </el-row>
           <el-row>
               <el-col :lg="10" :offset="2">
                <el-button type="primary" @click="fetchMemberGiftList">查詢</el-button>
               </el-col>
               <el-col :lg="12"></el-col>
           </el-row>
     </el-form>
     <el-row>
         <el-col :lg="2" :offset="20">
         <el-button type="primary" @click="diaAddVisible = true">新增</el-button>
         <el-dialog
             title="新增"
             :visible.sync="diaAddVisible"
             width="50%"
             center
             >
             <div class="dialog">
                 <el-form :rules="addRule" :model="addForm" ref="addForm" label-width="120px">
                 <el-form-item label="品牌">
                    <el-radio-group v-model="addForm.brand_id">
                        <el-radio  :label="1">N牌</el-radio>
                        <el-radio  :label="2">S牌</el-radio>
                    </el-radio-group>
                    
                 </el-form-item>
              
               <el-form-item label="品項:">
                   <el-input v-model="addForm.name" style="width:50%;"></el-input>
                   
               </el-form-item>
               <el-form-item label="兌換點數:">
                   <el-input v-model.number="addForm.exangePoint" type="number" style="width:50%;"></el-input>
                   
               </el-form-item>
               
               
             
             
               <el-form-item>
                   
                 <el-button @click="closeOpen('addForm')">取 消</el-button>
                 <el-button type="primary" @click="addMemberGift('addForm')">確 定</el-button>
                  </el-form-item>
                  </el-form>
             </div>
           
         </el-dialog>
         
         </el-col>
     </el-row>
     <el-row>
         <el-col :lg="22">
         <el-table :data="pointGiftList"
          :header-cell-style="tableHeaderColor">
             <el-table-column label="品牌" prop="brand_id">
             <template slot-scope="scope">
             <p> {{scope.row.brand_id == 1 ? 'N牌':'S牌'}}</p>
             </template>
             </el-table-column>
             <el-table-column label="品項" prop="name"></el-table-column>
             <el-table-column label="兌換點數" prop="exchange_point"></el-table-column>
             <el-table-column label="刪除">
              <template slot-scope="scope">
                <el-button type="primary" @click="deleteMemberGift(scope.$index, scope.row)" circle icon="el-icon-delete"></el-button>
                
              </template>
             </el-table-column>     
             
         </el-table>
         
         </el-col>
     </el-row>
     
     
    
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'change',
        data() {
            return {
                searchForm: {
                    brand_id: null,
                    name: ''
                },
                pointGiftList: [],
                addForm: {
                    brand_id: null,
                    name: '',
                    exangePoint: null
                },
                editForm: {
                    brand_id: null,
                    name:　'',
                    exangePoint: null
                },
                addRule: {
                    brand_id: [
                        {required: true, message: '請選擇品牌', trigger: 'bulr'}
                    ],
                    name: [
                        {required: true, message: '請填寫品項'}
                    ],
                    exangePoint: [
                        { required: true, message: '請填寫兌換點數'}
                    ]
                },
                diaAddVisible: false,
                diaEditVisible: false
            }
        },
        computed: mapGetters(["getMemberGiftList", "getMemberGiftError", "getMemberGIftMsg"]),
        methods: {
            ...mapActions(["fetchMemberGift", "addMemberGift", "updateMemberGift", "deleteMemberGift"]),
            async fetchMemberGiftList(){
                const data = {
                    brand_id: this.searchForm.brand_id,
                    name: this.searchForm.name
                }
                await this.$store.dispatch('fetchMemberGift', data)
                this.pointGiftList = this.getMemberGiftList
                console.log(typeof(this.pointGiftList));
            },
            async addMemberGift(formName){
                const data = {
                    brand_id: this.addForm.brand_id,
                    name: this.addForm.name,
                    exchange_point: this.addForm.exangePoint
                }
                await this.$store.dispatch('addMemberGift', data)
                if(this.getMemberGiftError != true){
                    this.$notify({
                        title: '成功',
                        message: '新增兌換禮品成功',
                        type: 'success',
                        duration: '4500',
                        position: 'top-right'
                    });
                    this.$refs[formName].resetFields()
                    this.diaAddVisible = false
                }else {
                    this.$notify({
                        title: '失敗',
                        message: this.getMemberGiftMsg,
                        type: 'error',
                        duration: '4500',
                        position: 'top-right'
                    });
                    
                }
            },
            async editMemberGift(formName){
                const data = {
                    brand_id: this.editForm.brand_id,
                    name: this.editForm.name,
                    exange_point: this.editForm.exangePoint
                }
                await this.$store.dispatch('editMemberGift', data)
                  if(this.getMemberGiftError != true){
                    this.$notify({
                        title: '成功',
                        message: '修改兌換禮品成功',
                        type: 'success',
                        duration: '4500',
                        position: 'top-right'
                    });
                    this.$refs[formName].resetFields()
                    this.diaEditVisible = false
                }else {
                    this.$notify({
                        title: '失敗',
                        message: this.getMemberGiftMsg,
                        type: 'error',
                        duration: '4500',
                        position: 'top-right'
                    });
                    
                }
            
            },
            async deleteMemberGift(index, row){
                const data = {_key: row._key}
                await this.$store.dispatch('deleteMemberGift', data)
                if(this.getMemberGiftError != true){
                    this.$notify({
                        title: '成功',
                        message: this.getMemberGiftMsg,
                        type: 'success',
                        duration: '4500',
                        position: 'top-right'
                    });
                    
                }else {
                    this.notify({
                        title: '失敗',
                        message: this.getMemberGiftMsg,
                        type: 'error',
                        duration: '4500',
                        position: 'top-right'
                    });
                    
                }
            },
            tableHeaderColor({row, column, rowIndex, columnIndex}){
                if(rowIndex === 0){
                    return `background-color: gray;color: #000;`
                }
            },
            closeOpen(formName){
                this.$refs[formName].resetFields()
                    this.diaAddVisible = false
            }
        },
    }
</script>